import React, { useState, useRef } from "react";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ReactToPrint from "react-to-print";
import SamtykkeText from "../Samtykke/SamtykkeText.js";
import { Link, useHistory } from "react-router-dom";
import API, { logout } from "../../actions";
import { Box, CircularProgress, Dialog, DialogContent, IconButton, Typography } from "@material-ui/core";
import { CheckCircleOutlined as CheckCircleOutlinedIcon } from "@material-ui/icons";
import { useSelector } from "react-redux";

const SyncStatus = {
    STARTED: "synkronisering...",
    COMPLETED: "synkroniseringen er afsluttet."
};

export default props => {
    const [anchorEl, setAnchorEl] = useState(null);
    const history = useHistory();
    const componentRef = useRef();
    const [dineroSyncDataStatus, setDineroSyncDataStatus] = useState(null);

    const therapist = useSelector(state => state.data.therapist);
    const isDineroConnected = therapist.dineroOrgId && therapist.dineroRefreshToken;

    const handleSyncDineroData = async () => {
        try {
            setDineroSyncDataStatus(SyncStatus.STARTED);
            const res = await API.syncDineroData();
            setDineroSyncDataStatus(SyncStatus.COMPLETED);
            setTimeout(() => {
                setDineroSyncDataStatus(null);
            }, 2000);
        } catch (err) {
            console.log({ err });
            setDineroSyncDataStatus(null);
        }
    };

    return (
        <div>
            {isDineroConnected ? (
                <IconButton onClick={handleSyncDineroData}>
                    <img src="synchronize.svg" alt="synchronize" style={{ height: "40px", width: "40px" }} />
                </IconButton>
            ) : null}
            <Button onClick={event => setAnchorEl(event.currentTarget)}>Konto</Button>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}>
                <Link
                    style={{ width: "100%" }}
                    to={{
                        pathname: "/Settings"
                    }}>
                    <MenuItem onClick={() => setAnchorEl(null)}>Firmaindstillinger</MenuItem>
                </Link>
                <Link
                    style={{ width: "100%" }}
                    to={{
                        pathname: "/Treatments"
                    }}>
                    <MenuItem onClick={() => setAnchorEl(null)}>Behandlinger</MenuItem>
                </Link>
                <Link
                    style={{ width: "100%" }}
                    to={{
                        pathname: "/NewPassword"
                    }}>
                    <MenuItem onClick={() => setAnchorEl(null)}>Password</MenuItem>
                </Link>
                <ReactToPrint trigger={() => <MenuItem>Samtykketekst</MenuItem>} content={() => componentRef.current} />
                <div style={{ display: "none" }}>
                    <div ref={componentRef}>
                        <SamtykkeText />
                    </div>
                </div>
                <MenuItem
                    onClick={() => {
                        logout();
                        history.push("/");
                    }}>
                    Log ud
                </MenuItem>
            </Menu>
            <Dialog maxWidth="md" open={Boolean(dineroSyncDataStatus)} aria-labelledby="form-dialog-title">
                <DialogContent>
                    <Box
                        padding={"40px"}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                        }}>
                        {dineroSyncDataStatus === SyncStatus.STARTED ? (
                            <CircularProgress />
                        ) : (
                            <CheckCircleOutlinedIcon
                                htmlColor="#23AF0C"
                                style={{
                                    fontSize: "50px"
                                }}
                            />
                        )}
                        <Typography
                            style={{
                                marginTop: "20px",
                                fontWeight: "bold"
                            }}>
                            {dineroSyncDataStatus}
                        </Typography>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    );
};
